import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { TAG_PUBLISHER } from '../../analytics/analytics.tagids.constants'
import { selectIsComputingDone } from '../../../store/itinerary/itinerary.selectors'
import { PUB_TAG } from '../../analytics/PublisherTagsService'
import useConfigureAndSendTag from '../../analytics/useConfigureAndSendTag'
import TagActionLink from '../../genericComponents/TagActionLink'
import euro from '../../genericComponents/assets/euro.svg'
import { withFrenchSite } from '../../i18n/i18nSite'
import SVGIcon from '../../svg/SVGIcon'
import s from './HotDeals.less'

const HotDeal = props => {
  const { name, description, ctaLabel, ctaLink, tagId } = props

  return (
    <li className={s.item}>
      <div className={s.itemTitle}>{name}</div>
      <p>{description}</p>
      <TagActionLink
        className={s.itemLink}
        href={ctaLink}
        targetBlank={true}
        nofollow={true}
        type={TAG_PUBLISHER}
        tagInfo={{ tag: PUB_TAG.PUB_ATC_MULTIPATH_BONS_PLANS_DEPLACEMENT, PartnerLabel: tagId }}
      >
        {ctaLabel}
      </TagActionLink>
    </li>
  )
}

const renderBlaBlaCar = () => {
  return (
    <HotDeal
      name="Covoiturez et économisez avec BlaBlaCar"
      description="Devenez conducteur BlaBlaCar et économisez 60€ sur votre prochain trajet"
      ctaLabel="Conduisez malin"
      tagId="blablacar"
      ctaLink="https://www.blablacar.fr/?comuto_cmkt=FR_MAPPY_ACQ_DRVR_BONUSCOVOITURAGE_COMMENTCAMARCHE"
    />
  )
}

const renderUlys = () => {
  return (
    <HotDeal
      name="Pass Ulys Télépéage : 12 mois offerts"
      description="Simplifiez vos passages au péage sur toutes les autoroutes de France"
      ctaLabel="J'en profite"
      tagId="ulys"
      ctaLink="https://ulys.com/landings/offre-promo-telepeage-ulys-brand-V3/?&utm_medium=display-consideration&at_medium=display-consideration&utm_source=Mappy&at_campaign_group=Mappy&utm_campaign=Acqui-B2C-Display-consi-Mappy-CPM-Consideration-C2MAP01-FR&at_campaign=Acqui-B2C-Display-consi-Mappy-CPM-Consideration-C2MAP01-FR&utm_content=Bonsplans&at_creative=statique&at_format=Bonsplans&at_type=conquete&at_variant=FR"
    />
  )
}

const HotDeals = () => {
  const configureAndSendTag = useConfigureAndSendTag()
  const isComputingDone = useSelector(selectIsComputingDone)

  useEffect(() => {
    if (isComputingDone) {
      configureAndSendTag({
        type: TAG_PUBLISHER,
        tagInfo: {
          tag: PUB_TAG.PUB_ATI_MULTIPATH_BONS_PLANS_DEPLACEMENT
        },
        isImpression: true
      })
    }
  }, [isComputingDone])

  if (!isComputingDone) return <></>

  return (
    <div className={s.root}>
      <div className={s.title}>
        Nos bons plans déplacement
        <div className={s.euroIcon}>
          <SVGIcon url={euro} />
        </div>
      </div>
      <ul>
        {renderBlaBlaCar()}
        {renderUlys()}
      </ul>
    </div>
  )
}

export default withFrenchSite(HotDeals)
